import React, { Component } from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';

import './App.css';
import {Route,BrowserRouter,Switch} from 'react-router-dom';
import NotFoundRoute from './Pages/NotFoundRoute/NotFoundRoute';

import Signin from './Pages/Signin/Signin';
import Signup from './Pages/Signup/Signup';
import ConfirmData from './Pages/ConfirmData/ConfirmData';
import ConfirmPhone from './Pages/ConfirmData/ConfirmPhone';
import ConfirmEmail from './Pages/ConfirmData/ConfirmEmail';
import Confirmmaildone from './Pages/ConfirmData/Confirmmaildone';
import ForgetPassword from './Pages/ConfirmData/ForgetPassword';
import Resetpassword from './Pages/ConfirmData/Resetpassword';
import CourierConfirmPhone from './Pages/ConfirmData/CourierConfirmPhone';
import Home from './Pages/Home/Home';
import FAQS from './Pages/FAQS/FAQS';
import Termsconditions from './Pages/Termsconditions/Termsconditions';
import Policy from './Pages/Policy/Policy';
import ContactUs from './Pages/ContactUs/ContactUs';
import Orders from './Pages/Orders/Orders';
import OrderDetail from './Pages/OrderDetail/OrderDetail';
import CreateOrder from './Pages/CreateOrder/CreateOrder';
import Replaceorder from './Pages/Replaceorder/Replaceorder';
import OrderConfirmation from './Pages/OrderConfirmation/OrderConfirmation';
import MyClients from './Pages/MyClients/MyClients';
// import MyClientsEdit from './Pages/MyClientsEdit/MyClientsEdit';
import MyClientsLocation from './Pages/MyClientsLocation/MyClientsLocation';
// import MyClientsLocationEdit from './Pages/MyClientsLocationEdit/MyClientsLocationEdit';
import ClientWallet from './Pages/ClientWallet/ClientWallet';
import Profile from './Pages/Profile/Profile';


import SigninAR from './Pages/AR/Signin/Signin';
import SignupAR from './Pages/AR/Signup/Signup';
import ConfirmDataAR from './Pages/AR/ConfirmData/ConfirmData';
import ConfirmPhoneAR from './Pages/AR/ConfirmData/ConfirmPhone';
import ConfirmEmailAR from './Pages/AR/ConfirmData/ConfirmEmail';
import ConfirmmaildoneAR from './Pages/AR/ConfirmData/Confirmmaildone';
import ForgetPasswordAR from './Pages/AR/ConfirmData/ForgetPassword';
import ResetpasswordAR from './Pages/AR/ConfirmData/Resetpassword';
import HomeAR from './Pages/AR/Home/Home';
import FAQSAR from './Pages/AR/FAQS/FAQS';
import TermsconditionsAR from './Pages/AR/Termsconditions/Termsconditions';
import PolicyAR from './Pages/AR/Policy/Policy';
import ContactUsAR from './Pages/AR/ContactUs/ContactUs';
import OrdersAR from './Pages/AR/Orders/Orders';
import OrderDetailAR from './Pages/AR/OrderDetail/OrderDetail';
import ReplaceorderAR from './Pages/AR/Replaceorder/Replaceorder';
import CreateOrderAR from './Pages/AR/CreateOrder/CreateOrder';
import OrderConfirmationAR from './Pages/AR/OrderConfirmation/OrderConfirmation';
import MyClientsAR from './Pages/AR/MyClients/MyClients';
// import MyClientsEditAR from './Pages/AR/MyClientsEdit/MyClientsEdit';
import MyClientsLocationAR from './Pages/AR/MyClientsLocation/MyClientsLocation';
// import MyClientsLocationEditAR from './Pages/AR/MyClientsLocationEdit/MyClientsLocationEdit';
import ClientWalletAR from './Pages/AR/ClientWallet/ClientWallet';
import ProfileAR from './Pages/AR/Profile/Profile';

// import SigninCourierAR from './Pages/AR/SigninCourier/SigninCourier';
import SignupCourierAR from './Pages/AR/SignupCourier/SignupCourier';
import CourierConfirmPhoneAR from './Pages/AR/ConfirmData/CourierConfirmPhone';
import SignupCourier from './Pages/Admin/SignupCourier/SignupCourier';
import ScrollToTop from './ScrollToTop ';

class RoutesUser extends Component  {
 



  render() {

  return (
    <div className="App">
      <div className="ForDemo"> DEMO</div>
      <BrowserRouter>
      <ScrollToTop>
      <Switch>

      <Route exact path='/' component={Home}/>
      <Route exact path='/FAQS' component={FAQS}/>
      <Route exact path='/Termsconditions' component={Termsconditions}/>
      <Route exact path='/Policy' component={Policy}/>
      <Route exact path='/ContactUs' component={ContactUs}/>
      <Route exact path='/Courier/Signup' component={SignupCourier}/>
      <Route exact path='/Courier/ConfirmPhone' component={CourierConfirmPhone}/>
      <Route exact path='/Signin' component={Signin}/>
      <Route exact path='/Signup' component={Signup}/>
      <Route exact path='/ForgetPassword' component={ForgetPassword}/>
      <Route exact path='/Resetpassword/:Token' component={Resetpassword}/>
      <Route exact path='/ConfirmData' component={ConfirmData}/>
      <Route exact path='/ConfirmEmail/:Token' component={ConfirmEmail}/>
      <Route exact path='/ConfirmPhone' component={ConfirmPhone}/>
      <Route exact path='/Confirmchangeemail/:Token' component={Confirmmaildone}/>

      <Route exact path='/Orders' component={Orders}/>
      <Route exact path='/OrderDetail/:id' component={OrderDetail}/>
      <Route exact path='/NewOrder' component={CreateOrder}/>
      <Route exact path='/Replaceorder/:id' component={Replaceorder}/>
      <Route exact path='/OrderConfirmation/:id' component={OrderConfirmation}/>
      <Route exact path='/MyClients' component={MyClients}/>
      <Route exact path='/ClientAdderss' component={MyClientsLocation}/>
      <Route exact path='/Wallet' component={ClientWallet}/>
      <Route exact path='/Profile' component={Profile}/>

 
      <Route exact path='/AR/' component={HomeAR}/>
      <Route exact path='/AR/FAQS' component={FAQSAR}/>
      <Route exact path='/AR/Termsconditions' component={TermsconditionsAR}/>
      <Route exact path='/AR/Policy' component={PolicyAR}/>
      <Route exact path='/AR/ContactUs' component={ContactUsAR}/>      
      <Route exact path='/AR/Signin' component={SigninAR}/> 
      <Route exact path='/AR/Signup' component={SignupAR}/>
      <Route exact path='/AR/Courier/Signup' component={SignupCourierAR}/> 
      <Route exact path='/AR/Courier/ConfirmPhone' component={CourierConfirmPhoneAR}/> 
      <Route exact path='/AR/ForgetPassword' component={ForgetPasswordAR}/>
      <Route exact path='/AR/Resetpassword/:Token' component={ResetpasswordAR}/>
      <Route exact path='/AR/ConfirmData' component={ConfirmDataAR}/>
      <Route exact path='/AR/ConfirmEmail/:Token' component={ConfirmEmailAR}/>
      <Route exact path='/AR/ConfirmPhone' component={ConfirmPhoneAR}/>
      <Route exact path='/AR/Confirmchangeemail/:Token' component={ConfirmmaildoneAR}/>

      <Route exact path='/AR/Orders' component={OrdersAR}/>
      <Route exact path='/AR/OrderDetail/:id' component={OrderDetailAR}/>
      <Route exact path='/AR/Replaceorder/:id' component={ReplaceorderAR}/>
      <Route exact path='/AR/NewOrder' component={CreateOrderAR}/>
      <Route exact path='/AR/OrderConfirmation/:id' component={OrderConfirmationAR}/>
      <Route exact path='/AR/MyClients' component={MyClientsAR}/>
      {/* <Route exact path='/AR/MyClients/Edit' component={MyClientsEditAR}/> */}
      <Route exact path='/AR/ClientAdderss' component={MyClientsLocationAR}/>
      {/* <Route exact path='/AR/ClientAdderss/Edit' component={MyClientsLocationEditAR}/> */}
      <Route exact path='/AR/Wallet' component={ClientWalletAR}/>
       <Route exact path='/AR/Profile' component={ProfileAR}/>
       <Route exact  component={NotFoundRoute}/>

       </Switch>

      

      </ScrollToTop>

      </BrowserRouter>
    </div>
  );
}
}

export default RoutesUser;
